import { useState, useEffect, useCallback } from "react";
import { AppError } from "@/lib/utils/errors";
import { conversationService } from "@/modules/services/conversation/conversationService";
import { useBusinessInfoStore } from "@/modules/store/businessInfoStore";

export const useUnreadConversations = () => {
  const { businessInfo } = useBusinessInfoStore();
  const [totalUnreadConversations, setTotalUnreadConversations] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const loadUnreadConversationsCount = useCallback(async () => {
    if (!businessInfo?.id) return;

    setIsLoading(true);
    try {
      const response = await conversationService.getTotalUnreadConversation(
        businessInfo.id
      );
      if (response && response.total !== undefined) {
        setTotalUnreadConversations(response.total);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.logError(
        "src/modules/hooks/conversations/useUnreadConversations.ts[loadUnreadConversationsCount]"
      );
    } finally {
      setIsLoading(false);
    }
  }, [businessInfo?.id]);

  useEffect(() => {
    if (businessInfo && businessInfo?.id) {
      loadUnreadConversationsCount();
    }
  }, [businessInfo, loadUnreadConversationsCount]);

  return {
    totalUnreadConversations,
    isLoading,
    loadUnreadConversationsCount,
  };
};
